import { BaseSocketService } from './baseSocketServiceSocketIO';

class RemoteStepServiceSocketIO extends BaseSocketService {
    listeners: { [resultId: string]: (data: any) => void } = {};

    override init(projectId: string) {
        super.init(projectId, 'remoteStep');
        this.listeners = {};
    }

    override emitJoinRoom(resultId: string) {
        return this.emitPromise('remoteStep:join', { resultId });
    }

    emitLeaveRoom(resultId: string) {
        return this.emitPromise('remoteStep:leave', { resultId });
    }

    async joinToRemoteStep(resultId: string) {
        if (this.rooms[resultId]) {
            return;
        }
        this.joinRoom(resultId);
        await this.emitJoinRoom(resultId);
    }

    listenToRemoteStep(resultId: string, onRemoteStep: (data: any) => void) {
        if (this.listeners[resultId]) {
            this._socket!.off('remoteStep:saved', this.listeners[resultId]);
            delete this.listeners[resultId];
        }

        this.listeners[resultId] = data => {
            if (data.resultId === resultId && data.remoteStep && data.remoteStep.status === 'pending') {
                onRemoteStep(data.remoteStep);
            }
        };
        this._socket!.on('remoteStep:saved', this.listeners[resultId]);
    }

    async unlistenToRemoteStep(resultId: string) {
        if (!this.listeners[resultId]) {
            return;
        }

        this.leaveRoom(resultId);
        this._socket!.off('remoteStep:saved', this.listeners[resultId]);
        delete this.listeners[resultId];
        await this.emitLeaveRoom(resultId);
    }
}

export const remoteStepServiceSocketIO = new RemoteStepServiceSocketIO();
